<template>
  <div class="stps">
    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="stps-item" v-for="(item, index) in list" :key="index">
      <div class="outer-circle" v-if="index == 0">
        <div class="inner-circle"></div>
        <div class="line" v-if="list.length !== index + 1"></div>
      </div>
      <div class="noactive-outer-circle" v-else>
        <div class="outer-circle">
          <div class="inner-circle"></div>
          <div class="line" v-if="list.length !== index + 1"></div>
        </div>
      </div>

      <div class="step-text">
        <span class="time" :style="{ color: index == 0 ? '#236dff' : '' }">{{ filter.filterTime(item.createTime, 'YYYY-MM-DD HH:mm') }}</span>
        <span class="state" :style="{ color: index == 0 ? '#236dff' : '' }">{{ item.agentName }}</span>
        <span class="desc" :style="{ color: index == 0 ? '#236dff' : '' }">{{ filterFollowUpStatus(item.status) }}</span>
        <Tooltip :content="item.content" :max-width="300" class="tooltip" v-if="item.content">
          <span class="desc-text">{{ item.content }}</span>
        </Tooltip>
        <span class="tooltip" v-else>-</span>
        
        <span class="desc-communicate"><span>沟通方式：{{ item.type?filterCommunicateType(item.type):'-' }}</span>  <span>沟通时长：{{ item.chatTime?formatSeconds(item.chatTime):"-" }}</span></span>
        <span class="next-communicate">下次沟通时间：{{ item.nextChatDate?filter.filterTime(item.nextChatDate, 'YYYY-MM-DD HH:mm'):'-' }}</span>
        <a class="action" v-if="item.record&&item.record !='{}'" @click="download(item.record)">下载录音</a>
        <a class="action-no" v-else></a>

        <div class="action-box" v-if="item.agentId == userId">
          <a @click="deleteItem(item)"><img src="@/assets/images/icon/org/delete-01.png"></a>
          <a @click="$refs.editFollowUp.open(item)"><img src="@/assets/images/icon/org/edit-01.png"></a>
        </div>
        <div v-else class="action-box"></div>

        <div class="follow-up-btn" v-if="index==0" @click="$refs.addFollowUp.open(item)">
          <img src="@/assets/images/icon/org/edit-02.png">
          <span>跟进</span>
        </div>
      </div>
    </div>

    <!-- 修改 -->
    <edit-follow-up ref="editFollowUp" :getInsureList="getInsureList"></edit-follow-up>

    <!-- 跟进 -->
    <add-follow-up ref="addFollowUp" :getInsureList="getInsureList" :isDetail="true"></add-follow-up>

    <no-data v-if="!list.length"></no-data>
  </div>
</template>
<script>
import filter from "@/api/filter";
import { getFollowUpStatusList, getCommunicateType } from '../../form/api';
import editFollowUp from './editFollowUp';
import addFollowUp from './addFollowUp';

export default {
  name: "detailFollowUpRecord",
  props:['id'],
  components:{ editFollowUp, addFollowUp },
  data() {
    return {
      filter,
      list:[],
      followUpStatusList:[],//跟进状态
      communicateTypeList:[],//沟通方式
      userId:JSON.parse(localStorage.getItem('userInfo')).userid
    };
  },
  created() {
    this.queryFollowUpStatus();
    this.queryCommunicateType();
    this.getInsureList();    
  },

  methods: {
    // 跟进状态
    async queryFollowUpStatus() {
      const { data } = await getFollowUpStatusList();
      this.followUpStatusList = data.filter(item=>item.value !='-1');
    },

    // 处理跟进状态
    filterFollowUpStatus(value) {
      let str = '';
      this.followUpStatusList.filter(item=>{
        if(item.value == value){
          str = item.txt;
        }
      })
      return str;
    },
    

    // 沟通方式
    async queryCommunicateType() {
      const { data } = await getCommunicateType();
      this.communicateTypeList = data;
    },

    // 处理沟通方式
    filterCommunicateType(value) {
      let str = '';
      this.communicateTypeList.filter(item=>{
        if(item.value == value){
          str = item.txt;
        }
      })
      return str;
    },

    // 获取列表
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: `/buz/customerBase/read/follow/list/${this.id}`,
        type: "POST",
      }).then((res) => {
        this.$root.$children[0].isShowLoading = false;
        this.list = res.data;
      }).catch((e) => {
        console.log(e)
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 录音下载
    download(item) {
      let data = JSON.parse(item);
      this.getBlob(data.url).then(blob => {
        this.saveAs(blob, data.name);
      })
    },

    saveAs(blob, filename) {
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename;
      link.click();
    },

    // 将url转成blob文件
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send();
      })
    },

    // 删除
    deleteItem(item) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: `/buz/customerFollowRecord/del`,
          type: "GET",
          data:{
            id:item.id
          }
        }).then((res) => {
          this.$Message.success("删除成功");
          this.getInsureList();
        })
      })
    },

    //秒数转化为时分秒
    formatSeconds(value) {
      var secondTime = parseInt(value) * 60; // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + parseInt(secondTime)>0?parseInt(secondTime) + "秒":'';

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分钟" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
      }
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.stps {
  .stps-item {
    margin-bottom: 19px;
    display: flex;
    align-items: center;
    .outer-circle {
      width: 11px;
      height: 11px;
      border: 1px solid #236dff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex-shrink: 0;
    }
    .inner-circle {
      background-color: #236dff;
      width: 7px;
      height: 7px;
      border-radius: 50%;
    }
    .line {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: 8px;
      margin-left: -1px;
      height: 25px;
      border-left: 1px dashed #d0d2d5;
    }

    .noactive-outer-circle {
      width: 11px;
      height: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex-shrink: 0;
      .outer-circle {
        width: 11px;
        height: 11px;
        background: #F7F7F7;
        border: 1px solid #F7F7F7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex-shrink: 0;
      }
      .inner-circle {
        background-color: #d0d2d5;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin-left: -1px;
      }
      .line {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 7px;
        margin-left: -1px;
        height: 25px;
        border-left: 1px dashed #d0d2d5;
      }
    }

    .step-text {
      margin-left: 10px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666e7b;
      .time {
        width: 150px;
        font-size: 13px;
      }
      .state {
        width: 90px;
        color: #000;
        font-size: 13px;
      }
      .desc {
        width: 110px;
        font-size: 13px;
      }
      .tooltip {
        width:350px;
        padding-right: 50px;
        display: flex;
        align-items: center;
      }
      .desc-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        font-size: 13px;
      }
      .desc-communicate {
        width: 250px;
        color: #727C8E;
        font-size: 13px;
      }
      .next-communicate {
        width: 180px;
        color: #515C6F;
        margin-left: 20px;
        font-size: 13px;
      }
      .action {
        width: 80px;
        margin-left: 60px;
        color: #236DFF;
      }
      .action-no {
        margin-left: 60px;
        width: 80px;
      }
      .action-box {
        margin-left: 20px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 10px;
        }
      }
      .follow-up-btn {
        margin-left: 60px;
        width: 80px;
        height: 30px;
        border-radius: 2px;
        background-color: #236DFF;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 10px;
          height: 10px;
          margin-right: 4px;
        }
        span {
          font-size: 12px;
          color: #FFFFFF;
        }
      }
      .follow-up-btn:hover {
        cursor: pointer;
      }
    }
  }
}
</style>